import React from "react";
import DeleteModal from "../../Modal/DeleteModal";

export function CountryDeleteModal({
  isLoadingDeleteCountry,
  onClickOfSaveButton,
  onClickOfCancelButton,
  isDeleteModal,
}) {
  return (
    <>
      <DeleteModal
        isLoading={isLoadingDeleteCountry}
        handleDeleteHide={onClickOfCancelButton}
        isDeleteModal={isDeleteModal}
        title={"Country Delete"}
        message={"Are you sure to permanently delete this Country?"}
        onClickOfSaveButton={onClickOfSaveButton}
        onClickOfCancelButton={onClickOfCancelButton}
        saveButtonLabel={"Delete"}
        cancelButtonLabel={"Cancel"}
      />
    </>
  );
}
